import { Appointment } from 'src/models/appointment';
import { AbstractCommand } from 'src/models/command';

import { parseWallClockAsLocal } from 'src/util/date';

class EditExistingAppointmentCommand extends AbstractCommand {
	readonly name = 'IFS_Calendar_Command_Commands_EditExistingAppointment';
	readonly processId = 'random';

	public constructor(appointment: Appointment) {
		super();
		const startDate = parseWallClockAsLocal(appointment.startDate);
		const endDate = parseWallClockAsLocal(appointment.endDate);

		this.parameters = {
			access: appointment.access,
			alert: appointment.alert,
			appointmentId: appointment.appointmentId,
			appointmentType: appointment.appointmentType,
			date: startDate.getTime(),
			description: appointment.description,
			duration: (endDate.getTime() - startDate.getTime()) / 60000,
			location: String(appointment.location),
			newAppointment: false,
			participant: JSON.stringify(appointment.participantsOfAppointment),
			repetition: JSON.stringify(appointment.calendarModelRepetition),
			repetitionStatus: appointment.calendarModelRepetition.repetitionType !== 'none',
			startHour: startDate.getHours(),
			startMinute: startDate.getMinutes(),
			timeMode: appointment.timeMode,
			title: appointment.title,
		};
	}
}

export { EditExistingAppointmentCommand };
